export default "__VITE_ASSET__rPdq0Ny3__"